import { jsx as _jsx } from "react/jsx-runtime";
import { Box, FlexGrid } from '@telus-uds/components-web';
export var DeviceOptions = function (_a) {
    var children = _a.children;
    return (_jsx(FlexGrid, { gutter: false, children: _jsx(FlexGrid.Row, { children: _jsx(FlexGrid.Col, { xsOffset: 0, lgOffset: 4, xlOffset: 3, lg: 8, xl: 9, children: _jsx(Box, { left: { md: 4, lg: 0, xl: 6 }, children: children }) }) }) }));
};
